import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const siteNav = [
  { to: "/", label: "首页" },
  { to: "/archive", label: "考古合集" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

const Footer = () => (
  <footer className="bg-secondary-950 text-background-100">
    <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-archive-2-line text-2xl"></i>
            </span>
            <span className="font-heading text-2xl font-black text-background-50">考古坞</span>
          </div>
          <p className="mt-4 max-w-md font-label text-sm leading-relaxed text-background-200/80">
            一个做娱乐往事整理的档案室。我们把被时间盖住的旧料翻出来，按年代归档、按要求核对，
            不是为了追究谁，只是想让那些值得被记住的事，再被看见一次。
          </p>
          <p className="mt-5 font-label text-xs tracking-[0.18em] text-accent-400">
            旧料翻出 · 年代考证 · 冷静回看
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-base font-bold text-background-50">站点导航</h4>
          <ul className="mt-4 space-y-2.5">
            {siteNav.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="font-label text-sm text-background-200/80 transition-colors hover:text-accent-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading text-base font-bold text-background-50">分类归档</h4>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {categories.map((cat) => (
              <li key={cat.id}>
                <Link
                  to={`/archive?cat=${cat.id}`}
                  className="font-label text-sm text-background-200/80 transition-colors hover:text-accent-400"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-6 space-y-2 font-label text-sm text-background-200/80">
            <p className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-accent-400"></i>
              hello@kaogudock.cn
            </p>
            <p className="flex items-center gap-2">
              <i className="ri-time-line text-base text-accent-400"></i>
              每周二、周五更新
            </p>
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 font-label text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 考古坞 · 娱乐往事档案室 · 内容仅供回顾讨论</p>
        <p className="flex items-center gap-4">
          <span>更正与撤稿请联系上方邮箱</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;